import { useNavigate } from "react-router-dom";
import { ArrowLeft, Home, XCircle } from "lucide-react";

import { OutcomeState } from "@/components/app/outcome-state";
import { Button } from "@/components/ui/button";

export const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <OutcomeState
      eyebrow="Payment Status"
      title="Payment cancelled"
      description="The transaction was cancelled before completion. No charges have been applied to your account."
      icon={XCircle}
      tone="warning"
      meta={
        <div className="space-y-1">
          <p className="font-medium">No funds captured</p>
          <p className="text-sm opacity-80">
            You can retry from the previous screen when you are ready.
          </p>
        </div>
      }
      actions={
        <>
          <Button variant="outline" onClick={() => navigate(-1)}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            Try again
          </Button>
          <Button onClick={() => navigate("/dashboard")}>
            <Home className="mr-2 h-4 w-4" />
            Dashboard
          </Button>
        </>
      }
    />
  );
};
